wbApp.controller('FormsDetailCtrl', ['$scope', '$modal', 'formSvc', 'tenantSettingSvc',
function ($scope, $modal, formSvc, tenantSettingSvc) {

    $scope.tenantSetting = tenantSettingSvc.settings;
    $scope.enableNewClientDesign = tenantSettingSvc.settings.enableNewClientDesign;
    
    $scope.modelOrig = angular.copy($scope.model);

    $scope.onDetailSave = function (data) {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (data.isNew) {
            formSvc.insert(data)
                .$promise.then(success, error);
        } else {
            formSvc.update(data)
                .$promise.then(success, error);
        }

        function success() {
            $scope.onFormSave();
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

    $scope.primaryQuestionIndexPlusOne = $scope.model.primaryQuestionIndex + 1;
    $scope.onPrimaryQuestionIndexPlusOneChange = function(newValue)
    {
        $scope.model.primaryQuestionIndex = newValue - 1;
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.onQuestionAdd = function () {
        formSvc.addNewQuestion($scope.model);
    }

    $scope.onQuestionRemove = function (question) {
        var index = $scope.model.questions.indexOf(question);
        if (index > -1) {
            $scope.model.questions.splice(index, 1);
        }
    }

    $scope.onOptionAdd = function (question) {
        formSvc.addNewOption(question);
    }

    $scope.onOptionRemove = function (question, option) {
        var index = question.options.indexOf(option);
        if (index > -1) {
            question.options.splice(index, 1);
        }
    }

    $scope.isFormValid = function() {
        return formSvc.isFormValid($scope.model);
    }

    $scope.onQuestionTypeChanged = function(question, questionType) 
    {
        if (questionType != 4)
        {
            if (!question.options || question.options.length == 0)
            {
                formSvc.addNewOption(question);
            }
        }
        else 
        {
            question.options = null;
        }
    }

    $scope.onDeletePictureBtnClick = function (pictureUrl) {
        _.pull($scope.model.pictureUrls || [], pictureUrl);
    }

    $scope.showPictureSelect = function () {
        picturesSelectDlgPromise.$promise.then(function () {
            picturesSelectDlgPromise.$scope.onPicturesSelected = function (pictures) {

                if (!$scope.model.pictureUrls) {
                    $scope.model.pictureUrls = [];
                }

                angular.forEach(pictures, function (p) {
                    if (!_.find($scope.model.pictureUrls, p.imageUrl)) {
                        $scope.model.pictureUrls.push(p.imageUrl);
                    }
                });
            };
            picturesSelectDlgPromise.show();
        });
    }
    
    $scope.onAccessPermissionChange = function() {
        if ($scope.model.accessPermissions != 0) {
            $scope.model.showFullEditableStudentDetail = false;

            if ($scope.model.accessPermissions != 3) {
                $scope.model.showFullEditableUserDetail = false;
                
                $scope.model.contractTemplateId = null;
                $scope.model.formType = 0;
            }
        }
    }

    var picturesSelectDlgPromise = $modal({
        templateUrl: 'storage/pictures/pictures-select-dlg.html',
        show: false,
        scope: $scope.$new()
    });

    $scope.detailTabs = [{
        title: 'TXT_MAIN',
        template: "forms/forms-detail-main-tab.html"
    },
    {
        title: 'TXT_LBL_SETTING',
        template: "forms/forms-detail-settings-tab.html"
    },
    {
        title: 'TXT_LBL_QUESTIONS',
        template: "forms/forms-detail-questions-tab.html"
    },
    {
        title: 'TXT_LBL_PICTURES',
        template: "forms/forms-detail-pictures-tab.html"
    }];

    $scope.detailTabs.activeTab = 0;

}]);
